export default __webpack_public_path__ + "static/media/PRODUCT_DEMO.cd6816d9.mp4";